// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"style_pageNotFound__HO0q_","topArticles":"style_topArticles__u0qaz","title":"style_title__PEd1n","artwork":"style_artwork__Dyq98","btn":"style_btn__kEW5X"};